export enum RequestListGroupType {
  OpenNotSet = 1000,
  InProgress = 2000,
  RepairedUnitShipped = 3000,
  Rejected = 4000,
}
export const RequestListGroupTypeList = [
  { value: 1000, label: "OPEN NOT SET" },
  { value: 2000, label: "IN PROGRESS" },
  { value: 3000, label: "REPAIRED UNIT SHIPPED" },
];
